import { api } from "../api/api"
import { ApiResponse } from "../models/base/ApiResponse"
import { ThemeInfoDTO } from "../models/theme/theme.response"



export const themeService = {

    async getThemeByLocalId(localId: string): Promise<ApiResponse<ThemeInfoDTO>> {
        const { data } = await api.get<ApiResponse<ThemeInfoDTO>>(`/locals/${localId}/themes`);

        return data;
    },

    async update(localId: string, id: string, dto: ThemeInfoDTO): Promise<ApiResponse<string>> {
        const { data } = await api.put<ApiResponse<string>>(`/locals/${localId}/themes/${id}`, dto);
        return data;
    }

}